import React, { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { useForm } from "react-hook-form";
import { useTranslation } from "react-i18next";
import Alert from "@material-ui/lab/Alert";
import { useIsAuthenticated } from "@azure/msal-react";

import { userActions } from "../../_redux/_actions";
import {
  Button,
  CircularProgress,
  FormHelperText,
  Grid,
  Typography,
  Paper,
  IconButton,
  InputAdornment,
  Link,
  // Chip,
  Hidden,
} from "@material-ui/core";
import { Visibility, VisibilityOff } from "@material-ui/icons";

import { SignInButton } from "../../_components";

import Logo from "./../../assets/images/logo_zoetis@2x.png";
import Thumb from "./../../assets/images/Group 2@2x.png";

import { useStyles, StyledTextField } from "./LoginPage.styles";

function LoginPage() {
  const { register, handleSubmit, errors } = useForm();
  const loggingIn = useSelector((state) => state.authentication.loggingIn);
  const loginError = useSelector((state) => state.authentication.loginError);
  const dispatch = useDispatch();
  const location = useLocation();
  const classes = useStyles();
  const isAuthenticated = useIsAuthenticated();
  const { t } = useTranslation(["login"]);
  const [showPassword, setShowPassword] = useState(false);
  const handleClickShowPassword = () => setShowPassword(!showPassword);
  const handleMouseDownPassword = () => setShowPassword(!showPassword);

  // reset login status
  useEffect(() => {
    if (!isAuthenticated) {
      dispatch(userActions.logout());
    }
  }, []);

  function onSubmit(e) {
    const { username, password } = e;

    if (username && password) {
      // get return url from location state or default to home page
      const { from } = location.state || { from: { pathname: "/" } };
      dispatch(userActions.login(username, password, from));
    }
  }

  return (
    <Grid container component="main" className={classes.root}>
      <Hidden smDown={true}>
        <Grid item xs={false} sm={3} md={5} className={classes.image}>
          <div className={classes.listWrapper}>
            <ul className={classes.list}>
              <li className={classes.listItem}>
                <Link href="#" underline="none">
                  <img
                    src={Logo}
                    className={classes.listItemLogo}
                    alt="zoetis logo"
                  ></img>
                </Link>
              </li>
            </ul>
          </div>
        </Grid>
      </Hidden>
      <Grid item xs={12} sm={12} md={7} component={Paper} square>
        <div className={classes.paper}>
          <div className={classes.thumb}>
            <img src={Thumb} className={classes.thumbImg} alt="vetscan fuse" />
          </div>
          <Typography component="h1" variant="h5" className={classes.title}>
            {t("login:login.title")}
          </Typography>
          {/* <Chip size="small" label="username/password : admin/admin or user/user" /> */}
          <form
            className={classes.form}
            noValidate
            onSubmit={handleSubmit(onSubmit)}
          >
            {process.env.REACT_APP_SHOW_AUTH_FORM == "true" && (
              <>
                <StyledTextField
                  inputRef={register({ required: "Username Required" })}
                  error={errors.username ? true : false}
                  disabled={loggingIn}
                  variant="standard"
                  margin="normal"
                  required
                  fullWidth
                  id="username"
                  label={t("login:login.username.label")}
                  name="username"
                  autoComplete="username"
                  autoFocus
                />
                <FormHelperText error={errors?.username}>
                  {errors?.username?.message}
                </FormHelperText>
                <StyledTextField
                  inputRef={register({ required: "password required" })}
                  InputProps={{
                    endAdornment: (
                      <InputAdornment position="end">
                        <IconButton
                          aria-label="toggle password visibility"
                          onClick={handleClickShowPassword}
                          onMouseDown={handleMouseDownPassword}
                        >
                          {showPassword ? <Visibility /> : <VisibilityOff />}
                        </IconButton>
                      </InputAdornment>
                    ),
                  }}
                  error={errors.password ? true : false}
                  disabled={loggingIn}
                  variant="standard"
                  margin="normal"
                  required
                  fullWidth
                  name="password"
                  label={t("login:login.password.label")}
                  type={showPassword ? "text" : "password"}
                  id="password"
                  autoComplete="current-password"
                />
                <FormHelperText error={errors?.password}>
                  {errors?.password?.message}
                </FormHelperText>
              </>
            )}
            {loginError && (
              <Alert
                className={classes.alert}
                variant="outlined"
                severity="error"
              >
                {loginError}
              </Alert>
            )}
            <Grid container spacing={1}>
              {process.env.REACT_APP_SHOW_AUTH_FORM == "true" && (
                <Grid item xs={6}>
                  <Button
                    type="submit"
                    fullWidth
                    variant="contained"
                    color="primary"
                    className={classes.submit}
                    disabled={loggingIn}
                  >
                    {t("login:login.loginbtn")}
                    {loggingIn && !isAuthenticated && (
                      <CircularProgress
                        size={24}
                        className={classes.buttonProgress}
                      />
                    )}
                  </Button>
                </Grid>
              )}
              <Grid
                item
                xs={process.env.REACT_APP_SHOW_AUTH_FORM == "true" ? 6 : 12}
              >
                <SignInButton></SignInButton>
              </Grid>
            </Grid>
          </form>
        </div>
      </Grid>
    </Grid>
  );
}

export { LoginPage };
